import './../styles/blog/blog.scss';

export default {
  init() {
    console.log('blog');
  },
  finalize() {
    const $blogMobileNav = $('#blog-mobile-nav');

    if ($blogMobileNav.length) {
      $blogMobileNav.on('change', function() {
        const url = $(this).val();
        if (url) {
          window.location = url;
        }
        return false;
      });
    }
  }
};
